import script from "./CampaignsManagementType.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignsManagementType.vue?vue&type=script&setup=true&lang=ts"

import "./CampaignsManagementType.vue?vue&type=style&index=0&id=5505bc60&lang=scss"

const __exports__ = script;

export default __exports__